import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { serverError500Codes } from 'utils/errorHandler';

// Components
import { Mui, MuiLab } from 'components';
import ExportButton from 'components/common/ExportButton';
import { ProgressWrapper, Stack } from 'components/layouts';

import Tanstack from './Tanstack';

function GraphicTableMainContent({
  viewType,
  renderChart,
  chartChildren,
  tableData,
  data,
  tableProps,
  noTableDataFoundMessage,
}) {
  const showChart = viewType === 'chart';
  const showTable = tableData && viewType === 'table';
  const hasData = tableData && Array.isArray(data) && data.length > 0;

  if (showChart) return renderChart ? renderChart(data) : chartChildren;
  if (showTable && hasData) {
    return <Tanstack columns={tableData} data={data} {...tableProps} />;
  }
  if (showTable) {
    return (
      <MuiLab.Alert severity="warning">
        {noTableDataFoundMessage || 'Nenhum dado encontrado no filtro selecionado'}
      </MuiLab.Alert>
    );
  }
  return null;
}

GraphicTableMainContent.propTypes = {
  viewType: PropTypes.string,
  renderChart: PropTypes.func,
  chartChildren: PropTypes.any,
  tableData: PropTypes.any,
  data: PropTypes.any,
  tableProps: PropTypes.object,
  noTableDataFoundMessage: PropTypes.string,
};

function GraphicTable({
  children,
  customExport,
  data,
  defaultViewType,
  error,
  exportData,
  exportFileName,
  filters,
  heading,
  subtitle,
  loading,
  mutate,
  noTableDataFoundMessage,
  tableData,
  tableProps,
  renderChart,
}) {
  // States
  const [viewType, setViewType] = useState(defaultViewType);

  return (
    <Stack>
      <Mui.Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        gridGap={10}
        alignContent="center"
        alignItems="center">
        <Mui.Box>
          {heading && typeof heading === 'string' ? (
            <Mui.Typography variant="h5">{heading}</Mui.Typography>
          ) : (
            heading
          )}
          {subtitle && (
            <Mui.Box marginTop={1}>
              {typeof subtitle === 'string' ? (
                <Mui.Typography variant="body2">{subtitle}</Mui.Typography>
              ) : (
                subtitle
              )}
            </Mui.Box>
          )}
        </Mui.Box>

        <Mui.Box display="flex" gridGap={10}>
          {customExport}
          <ExportButton fileName={exportFileName} data={exportData} />
          {(!!children || renderChart) && tableData && (
            <>
              {viewType === 'chart' ? (
                <Mui.Button color="primary" onClick={() => setViewType('table')}>
                  Ver Dados
                </Mui.Button>
              ) : (
                <Mui.Button color="primary" onClick={() => setViewType('chart')}>
                  Ver Gráfico
                </Mui.Button>
              )}
            </>
          )}
        </Mui.Box>
      </Mui.Box>

      {filters}

      <ProgressWrapper loading={loading}>
        {serverError500Codes.indexOf(error?.response?.status) !== -1 ? (
          <Mui.Button onClick={() => mutate?.()}>Recarregar</Mui.Button>
        ) : (
          <GraphicTableMainContent
            viewType={viewType}
            renderChart={renderChart}
            chartChildren={children}
            tableData={tableData}
            data={data}
            tableProps={tableProps}
            noTableDataFoundMessage={noTableDataFoundMessage}
          />
        )}
      </ProgressWrapper>
    </Stack>
  );
}

GraphicTable.propTypes = {
  children: PropTypes.any,
  customExport: PropTypes.any,
  data: PropTypes.any,
  defaultViewType: PropTypes.string,
  error: PropTypes.any,
  exportData: PropTypes.any,
  exportFileName: PropTypes.string,
  filters: PropTypes.any,
  heading: PropTypes.any,
  subtitle: PropTypes.any,
  loading: PropTypes.bool,
  mutate: PropTypes.func,
  noTableDataFoundMessage: PropTypes.string,
  tableData: PropTypes.any,
  tableProps: PropTypes.object,
  renderChart: PropTypes.func,
};

GraphicTable.defaultProps = {
  defaultViewType: 'chart',
};

export default GraphicTable;
